import * as Yup from "yup";
import i18n from "i18n";

export interface Inputs {
  name: string;
  startDate: Date | null;
  endDate: Date | null;
}

export const validationSchema = Yup.object({
  name: Yup.string(),
  startDate: Yup.date().typeError(i18n.t("Invalid Date")).nullable(),
  endDate: Yup.date()
    .typeError(i18n.t("Invalid Date"))
    .nullable()
    .test(
      "End date must come after start date",
      "End date must come after start date",
      function () {
        if (!this.parent.startDate || !this.parent.endDate) return true;
        return this.parent.startDate.getTime() <= this.parent.endDate.getTime();
      }
    ),
});

export const initialValues = {
  name: "",
  startDate: null,
  endDate: null,
};
